import { render } from "./ModelViewer.vue?vue&type=template&id=31dd98ac"
import script from "./ModelViewer.vue?vue&type=script&lang=js"
export * from "./ModelViewer.vue?vue&type=script&lang=js"

import "./ModelViewer.vue?vue&type=style&index=0&id=31dd98ac&lang=css"
script.render = render

export default script